export const FETCH_SERVICELINE_FAILURE = 'FETCH_SERVICELINE_FAILURE';
export const FETCH_SERVICELINE_LOADING = 'FETCH_SERVICELINE_LOADING';
export const FETCH_SERVICELINE_SUCCESS = 'FETCH_SERVICELINE_SUCCESS';

export const UPDATE_SERVICELINE_FAILURE = 'UPDATE_SERVICELINE_FAILURE';
export const UPDATE_SERVICELINE_LOADING = 'UPDATE_SERVICELINE_LOADING';
export const UPDATE_SERVICELINE_SUCCESS = 'UPDATE_SERVICELINE_SUCCESS';

export const ADD_SERVICELINE_FAILURE = 'ADD_SERVICELINE_FAILURE';
export const ADD_SERVICELINE_LOADING = 'ADD_SERVICELINE_LOADING';
export const ADD_SERVICELINE_SUCCESS = 'ADD_SERVICELINE_SUCCESS';

export const REMOVE_SERVICELINE_LOADING = 'REMOVE_SERVICELINE_LOADING';
export const REMOVE_SERVICELINE_SUCCESS = 'REMOVE_SERVICELINE_SUCCESS';
export const REMOVE_SERVICELINE_FAILURE = 'REMOVE_SERVICELINE_FAILURE';
